export * from './icon';

import { withInstall } from '../utils';
import IconCom, { icons } from './icon';
import "./icon.less"
export const iconall = icons;
export const FanIcon = withInstall(IconCom);
export default FanIcon;


// declare module 'vue' {
//   export interface GlobalComponents {
//     LanIcon: typeof Icon;
//   }
// }
